function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.4598 17.7185L19.9348 2.20157L18.8941 1.16095C18.657 0.925408 18.3364 0.793213 18.0022 0.793213C17.668 0.793213 17.3473 0.925408 17.1102 1.16095L0.544586 17.7185C0.301631 17.9605 0.109619 18.2488 -0.0201151 18.5662C-0.149849 18.8836 -0.214677 19.2239 -0.210771 19.5668C-0.1947 20.981 0.982533 22.1101 2.39682 22.1101H4.10441V35.1962H31.8999V22.1101H33.6437C34.3307 22.1101 34.9776 21.8409 35.4638 21.3547C35.7032 21.1161 35.8928 20.8324 36.0218 20.5199C36.1508 20.2075 36.2165 19.8726 36.2151 19.5346C36.2151 18.8516 35.9459 18.2047 35.4598 17.7185ZM20.2522 32.3034H15.7522V24.1069H20.2522V32.3034ZM29.0071 19.2172V32.3034H22.8236V23.1426C22.8236 22.2547 22.1044 21.5355 21.2165 21.5355H14.7879C13.8999 21.5355 13.1807 22.2547 13.1807 23.1426V32.3034H6.99726V19.2172H3.14012L18.0062 4.36318L18.9343 5.29131L32.8682 19.2172H29.0071Z",
  fill: "#6D7380"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.c221f3d2.svg";
export { ForwardRef as ReactComponent };